module.exports = __webpack_public_path__ + "img/holdIdVideo.ede23811.png";